import type { SVGProps } from 'react';

const baseProps = (props: SVGProps<SVGSVGElement>) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  fill: 'none' as const,
  viewBox: '0 0 24 24',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  width: 16,
  height: 16,
  'aria-hidden': true,
  ...props,
});

export const IconSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg {...baseProps(props)}>
    <circle cx="11" cy="11" r="7" />
    <path d="m20 20-3.5-3.5" />
  </svg>
);

export const IconX = (props: SVGProps<SVGSVGElement>) => (
  <svg {...baseProps(props)}>
    <path d="M18 6 6 18" />
    <path d="m6 6 12 12" />
  </svg>
);

export const IconChevronDown = (props: SVGProps<SVGSVGElement>) => (
  <svg {...baseProps(props)}>
    <path d="m6 9 6 6 6-6" />
  </svg>
);

export const IconChevronUp = (props: SVGProps<SVGSVGElement>) => (
  <svg {...baseProps(props)}>
    <path d="m6 15 6-6 6 6" />
  </svg>
);

export const IconChevronLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg {...baseProps(props)}>
    <path d="m15 18-6-6 6-6" />
  </svg>
);

export const IconChevronRight = (props: SVGProps<SVGSVGElement>) => (
  <svg {...baseProps(props)}>
    <path d="m9 18 6-6-6-6" />
  </svg>
);

export const IconChevronsUpDown = (props: SVGProps<SVGSVGElement>) => (
  <svg {...baseProps(props)}>
    <path d="m7 15 5 5 5-5" />
    <path d="m7 9 5-5 5 5" />
  </svg>
);

export const IconFilter = (props: SVGProps<SVGSVGElement>) => (
  <svg {...baseProps(props)}>
    <path d="M3 6h18" />
    <path d="M7 12h10" />
    <path d="M10 18h4" />
  </svg>
);

export const IconCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg {...baseProps(props)}>
    <path d="M20 6 9 17l-5-5" />
  </svg>
);

export const IconInbox = (props: SVGProps<SVGSVGElement>) => (
  <svg {...baseProps(props)}>
    <polyline points="22 12 16 12 14 15 10 15 8 12 2 12" />
    <path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11Z" />
  </svg>
);

export const IconFile = (props: SVGProps<SVGSVGElement>) => (
  <svg {...baseProps(props)}>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
  </svg>
);

export const IconArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg {...baseProps(props)}>
    <path d="M5 12h14" />
    <path d="m12 5 7 7-7 7" />
  </svg>
);

export const IconDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg {...baseProps(props)}>
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" x2="12" y1="15" y2="3" />
  </svg>
);

export const IconAlert = (props: SVGProps<SVGSVGElement>) => (
  <svg {...baseProps(props)}>
    <circle cx="12" cy="12" r="10" />
    <line x1="12" x2="12" y1="8" y2="12" />
    <line x1="12" x2="12.01" y1="16" y2="16" />
  </svg>
);
